/* ============================================================
   INTI FOCUS — Landing v2 interactions
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('.if-landing');
  if (!root) return;

  const vid       = root.dataset.vid;
  const basePrice = parseFloat(root.dataset.base || '9900') / 100;
  const fmt       = (n) => 'S/ ' + (+n).toFixed(2).replace(/\.00$/, '');

  /* ── Scroll reveals ─────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
    root.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
  } else {
    root.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }

  /* ── Scarcity bar ───────────────────────────────────── */
  const barFill = root.querySelector('.if-buy__bar-fill');
  if (barFill && 'IntersectionObserver' in window) {
    const target = barFill.style.getPropertyValue('--fill') || '0%';
    barFill.style.setProperty('--fill', '0%');
    const barIO = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      barFill.style.setProperty('--fill', target);
      barIO.unobserve(barFill);
    }, { threshold: 0.5 });
    barIO.observe(barFill);
  }

  /* ── Quantity selector ──────────────────────────────── */
  const opts        = root.querySelectorAll('[data-qty]');
  // NOTE: use data-price (not data-total) for the DISPLAY span
  // to avoid conflict with data-total on qty option buttons
  const priceEl     = root.querySelector('[data-price]');
  const compareEl   = root.querySelector('[data-compare]');
  const atcTextEl   = root.querySelector('[data-atc-text]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  let qty = 1;

  /* All buy-now elements — anchors + atc button */
  const buyTargets = root.querySelectorAll('[data-atc], [data-buy-now]');

  /* Update the cart permalink on every buy link so no-JS fallback is correct */
  function updateBuyHrefs(q) {
    buyTargets.forEach((el) => {
      if ('href' in el) el.href = '/cart/' + vid + ':' + q;
    });
  }

  function selectQty(q) {
    qty = parseInt(q, 10);
    opts.forEach((btn) => {
      const on = parseInt(btn.dataset.qty, 10) === qty;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    const btn   = root.querySelector('[data-qty="' + qty + '"]');
    if (!btn) return;
    const total = parseFloat(btn.dataset.total);
    const save  = parseFloat(btn.dataset.save);
    const full  = basePrice * qty;

    if (priceEl)     priceEl.textContent      = fmt(total);
    if (stickyPrice) stickyPrice.textContent  = fmt(total);

    if (compareEl) {
      compareEl.style.display = save > 0 ? 'inline' : 'none';
      if (save > 0) compareEl.textContent = fmt(full);
    }

    if (atcTextEl) {
      atcTextEl.textContent = qty === 1
        ? 'IR AL CHECKOUT →'
        : 'COMPRAR ' + qty + ' FRASCOS →';
    }

    updateBuyHrefs(qty);
  }

  opts.forEach((btn) => btn.addEventListener('click', () => selectQty(btn.dataset.qty)));

  /* Preselect pack 2 on load — pinta href y precios antes de cualquier clic */
  if (opts.length) selectQty(2);

  /* ── Toast ──────────────────────────────────────────── */
  const toast    = root.querySelector('[data-toast]');
  const toastMsg = root.querySelector('[data-toast-msg]');

  function showToast(msg) {
    if (!toast) return;
    if (toastMsg) toastMsg.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-on'), 2800);
  }

  /* ── Add to cart → direct checkout (AJAX) ───────────── */
  let buying = false;

  async function buyNow(triggerEl) {
    if (buying) return;

    /* If no variant ID, fall through to the href (cart permalink) */
    if (!vid || vid === '0') {
      if (triggerEl && triggerEl.href) {
        window.location.href = triggerEl.href;
      }
      return;
    }

    buying = true;
    const labelHost = triggerEl && triggerEl.querySelector('[data-atc-text]')
      ? triggerEl.querySelector('[data-atc-text]')
      : triggerEl;
    const originalLabel = labelHost ? labelHost.textContent : '';
    if (triggerEl && 'disabled' in triggerEl) triggerEl.disabled = true;
    if (triggerEl) triggerEl.setAttribute('aria-busy', 'true');
    if (labelHost) labelHost.textContent = 'PROCESANDO…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
      });

      if (!res.ok) throw new Error('cart-add-' + res.status);

      /* Success → go straight to checkout */
      window.location.href = '/checkout';

    } catch (err) {
      console.error('[IntiFocus ATC]', err);

      /* Fallback: use cart permalink so the customer can still buy */
      showToast('Redirigiendo al carrito…');
      setTimeout(() => {
        window.location.href = '/cart/' + vid + ':' + qty;
      }, 600);

      buying = false;
      if (triggerEl && 'disabled' in triggerEl) triggerEl.disabled = false;
      if (triggerEl) triggerEl.removeAttribute('aria-busy');
      if (labelHost) labelHost.textContent = originalLabel;
    }
  }

  buyTargets.forEach((el) => {
    el.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      buyNow(el);
    });
  });

  /* Set correct hrefs on page load */
  if (vid && vid !== '0') updateBuyHrefs(1);

  /* ── Sticky bar ─────────────────────────────────────── */
  const sticky = root.querySelector('[data-sticky]');
  const hero   = root.querySelector('.if-hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    const stickyIO = new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-on', !e.isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' });
    stickyIO.observe(hero);
  }

  /* ── Smooth anchor scroll ───────────────────────────── */
  /* Mismo breakpoint que el CSS de la sección (@media max-width:900px
     alterna hero/tarjetas a layout de tablet). Por encima de 900px,
     "#comprar" apunta directo a .if-qty en vez del inicio de la
     sección: la imagen del frasco empuja el selector fuera de vista
     si solo vamos al top de #comprar. En móvil/tablet no cambia. */
  const desktopMQ = window.matchMedia('(min-width: 901px)');
  const qtyEl = root.querySelector('.if-qty');

  /* Alto aproximado del header sticky (.if-header): padding-block 14px
     arriba/abajo + ~36px del contenido (logo/botón) ≈ 64px. El offset
     de escritorio debe superar esto claramente o el header lo tapa. */
  const HEADER_HEIGHT = 64;
  /* Contexto (px) que dejamos visible por encima de .if-qty en
     escritorio al ir a "#comprar" — recalibrar aquí, no en la fórmula. */
  const DESKTOP_QTY_CONTEXT = 160;

  root.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    let target = id ? document.getElementById(id) : null;
    if (!target) return;
    e.preventDefault();
    let offset = -24;
    if (id === 'comprar' && qtyEl && desktopMQ.matches) {
      target = qtyEl;
      offset = -Math.max(DESKTOP_QTY_CONTEXT, HEADER_HEIGHT);
    }
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY + offset, behavior: 'smooth' });
  });

  /* ── Parallax: pomo on scroll ───────────────────────── */
  const pomo = root.querySelector('.if-hero__pomo');
  if (pomo && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y < window.innerHeight * 1.5) pomo.style.marginTop = (-y * 0.06) + 'px';
        ticking = false;
      });
    }, { passive: true });
  }

})();
